import React from "react";
import { Card, Divider, Tag, Typography } from "antd";
import Dashboard from "../../../components/Kanban-Count-Accuracy/Dashboard/Dashboard";
import "../../../styles/global-ui.css";

const KanbanCountAccuracyDashbaordPage = ({ userdata, userData }) => {
  const pageUserData = userdata || userData;

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}.${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}.${today.getFullYear()}`;

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            KCA Dashboard
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Kanban count accuracy overview and activity
          </Typography.Text>
        </div>

        <Tag className="filter-tag" color="blue">
          Date: {formattedDate}
        </Tag>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <Dashboard userData={pageUserData} />
      </Card>
    </div>
  );
};

export default KanbanCountAccuracyDashbaordPage;